import * as React from 'react';

import { AppInkThicknessFullGallery, AppInkThicknessFullGalleryProps } from '@1js/acui-gallery-ink-thickness';

import { RibbonControlInternalProps } from '../../RibbonControlProps';

export class RibbonInkThicknessFullGallery extends React.PureComponent<
  AppInkThicknessFullGalleryProps & RibbonControlInternalProps,
  {}
> {
  public render() {
    return <AppInkThicknessFullGallery {...this.props} />;
  }
}
